<template>
    <div>
        <div class="pagination__items clearfix pb-3 text-right">
            <span class="pagination__items__label mr-4"> {{ configPage.total }} 件中 {{ from }}-{{ to }} 件表示 </span>
            <span>表示件数</span>
            <select v-model="configPage.limit" class="pagination__items__select ml-2" @change="onChange">
                <option v-for="value in perPageList" :key="value" :label="value + '件'" :value="value"></option>
            </select>
        </div>

        <div
            class="table-responsive position-relative"
            :style="`min-height:${loadingDefault ? '100%' : `${listDataTable.length > 0 && !loadingDefault ? '100%' : '150px'}`}; height:${heightTable ? heightTable : ''}`"
        >
            <table class="table table-bordered table-box table-hover table-resize">
                <template>
                    <colgroup v-if="config">
                        <col v-for="(item, colK) in config.headers" :key="colK" :style="{ width: item.width + 'px' }" />
                        <col :style="{ width: config?.widthAction + 'px' }" />
                    </colgroup>
                    <slot v-else name="colgroup"></slot>
                </template>
                <thead>
                    <tr v-if="config">
                        <th
                            v-for="(item, k) in config.headers"
                            :key="k"
                            class="text-left position-sticky"
                            :colspan="item.colSpan ?? 1"
                            :style="{ width: item.width + 'px', backgroundColor: item?.backgroundColor || '#ffffff', top: 0, zIndex: 20 }"
                            @mousedown="startResize($event, k)"
                        >
                            <div class="flex items-center el-table__cell">
                                {{ item.label }}
                                <span v-if="item.required" class="text-danger">*</span>
                                <span v-if="item.sort" :class="`sort ${item.sort.type ? item.sort.type : 'default'}`" @click="handleSort(item)">
                                    <i class="fas fa-sort-up"></i>
                                    <i class="fas fa-sort-down"></i>
                                </span>
                                <div v-if="item?.checkAll">
                                    <InputCheckBox
                                        class=""
                                        :model.sync="checkedAll"
                                        :id="`checkedAllTableList`"
                                        :value="checkedAll"
                                        :label="``"
                                        @change="onHandleCheckAllRecord"
                                    />
                                </div>
                            </div>
                            <span class="resize-handle"></span>
                        </th>
                        <th
                            :style="{ width: config?.widthAction + 'px', top: 0, zIndex: 20 }"
                            :class="`text-center ${stickyAction ? 'sticky_action' : ''}`"
                            v-if="visibleAction"
                        >
                            <!-- {{ $t('tableBox.action') }} -->
                        </th>
                    </tr>
                    <slot v-else name="head"></slot>
                </thead>
                <tbody v-if="listDataTable.length > 0 && !loadingDefault">
                    <template v-for="(row, index) in listDataTable">
                        <slot
                            :index="index + 1 + (configPage.page - 1) * configPage.limit"
                            :row="row"
                            :leng="row?.confirm?.length ? row?.confirm?.length : 1"
                            class="text-left"
                            name="row"
                        ></slot>
                    </template>
                </tbody>
                <tbody v-else-if="loadingDefault">
                    <template>
                        <tr style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); border: none">
                            <td style="border: none">
                                <div
                                    class="d-flex justify-content-center position-absolute"
                                    style="left: 50%; top: 50%; transform: translate(-50%, -50%)"
                                >
                                    <LoadingIcon />
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-else>
                    <template v-if="!['listOfRegisteredSerialCodes'].includes(id)">
                        <tr style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)">
                            <td style="border: none">
                                <p class="mt-3 text-center">
                                    {{ $t('notificationCommon.searchEmpty') }}
                                </p>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <Pagination
            v-if="configPage.total && listDataTable.length > 0 && !loadingDefault"
            :total="configPage.total"
            :page.sync="configPage.page"
            :per-page="configPage.limit"
            @changePage="onChangePage"
        ></Pagination>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import { InputCheckBox } from '@/components/Input';

export default {
    name: 'TableListComponent',
    components: {
        LoadingIcon,
        Pagination,
        InputCheckBox
    },
    props: {
        id: {
            type: [String, Number],
            default: ''
        },
        config: {
            type: Object,
            require: false
        },
        dataList: {
            type: Array,
            require: true,
            default: () => []
        },
        reload: {
            type: Boolean,
            default: () => false
        },
        isLoading: {
            type: Boolean,
            default: () => false
        },
        visibleAction: {
            type: Boolean,
            required: false,
            default: true
        },
        isCheckedAll: {
            type: Boolean,
            required: false,
            default: false
        },
        stickyAction: {
            type: Boolean,
            required: false,
            default: false
        },
        optionPageList: {
            type: Array,
            default: () => []
        },
        configPage: {
            type: Object,
            default: () => null
        },
        heightTable: {
            type: String,
            default: 'auto'
        }
    },
    computed: {
        from: function () {
            return (this.configPageDefault.page - 1) * this.configPageDefault.limit + 1;
        },
        to: function () {
            let to = this.configPageDefault.page * this.configPageDefault.limit;
            return to > this.configPageDefault.total ? this.configPageDefault.total : to;
        }
    },
    data() {
        return {
            configPageDefault: this.configPage,
            perPageList: this.optionPageList.length ? this.optionPageList : [10, 30, 50],
            listDataTable: this.dataList,
            checkedAll: false,

            resizing: false,
            currentColumnIndex: null,
            startX: 0,
            startWidth: 0,
            loadingDefault: true
        };
    },

    methods: {
        onChange() {
            this.configPageDefault.page = 1;
            this.$emit('onChangePage');
        },

        handleSort(sortItem) {
            if (sortItem.sort.type == 'asc') {
                sortItem.sort.type = 'desc';
            } else if (sortItem.sort.type == 'desc') {
                sortItem.sort.type = 'asc';
            } else {
                sortItem.sort.type = 'desc';
            }
            this.$emit('sort', sortItem);
        },

        onChangePage() {
            this.$emit('onChangePage');
        },

        onHandleCheckAllRecord() {
            this.$emit('toggleCheckAll', this.checkedAll);
        },

        startResize(e, index) {
            if (!e.target.classList.contains('resize-handle')) return;
            this.resizing = true;
            this.currentColumnIndex = index;
            this.startX = e.pageX;
            this.startWidth = this.config.headers[index].width;

            document.addEventListener('mousemove', this.onResize);
            document.addEventListener('mouseup', this.stopResize);
        },
        onResize(e) {
            if (!this.resizing) return;
            const dx = e.pageX - this.startX;
            const newWidth = Math.max(60, this.startWidth + dx);
            this.config.headers[this.currentColumnIndex].width = newWidth;
        },
        stopResize() {
            this.resizing = false;
            if (this.config?.nameTable) localStorage.setItem(this.config.nameTable, JSON.stringify(this.config.headers));
            document.removeEventListener('mousemove', this.onResize);
            document.removeEventListener('mouseup', this.stopResize);
        }
    },

    watch: {
        dataList: {
            handler: function (newData) {
                this.listDataTable = newData;
            },
            immediate: true,
            deep: true
        },
        configPage: {
            handler: function (newConfig) {
                this.configPageDefault = newConfig;
            },
            immediate: true,
            deep: true
        },

        configPageDefault: {
            handler: function (newConfig) {
                this.$emit('update:configPage', newConfig);
            },
            immediate: true,
            deep: true
        },
        isCheckedAll: {
            handler: function (newCheckAll) {
                this.checkedAll = newCheckAll;
            },
            immediate: true,
            deep: true
        },
        isLoading: {
            handler: function (newLoading) {
                this.loadingDefault = newLoading;
            },
            immediate: true,
            deep: true
        }
    },

    mounted() {
        if (this.config?.nameTable) {
            let data = localStorage.getItem(this.config.nameTable);
            if (data) {
                this.config.headers = JSON.parse(data);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.sort.default {
    color: lightgray;
}
</style>
